/* eslint-disable camelcase */
import Cookies from 'js-cookie'
import { App, computed } from 'vue'
import { createI18n } from 'vue-i18n'
import enLocal from './en'
import zhLocal from './zh'
import hkLocal from './hk'
import frLocal from './fr'
import router from '@/router/index'
import store from '@/store/index'

const langKey = 'language'

type Messages = {
  en_WW: {
    [key: string]: any
  }
  zh_CN: {
    [key: string]: any
  }
  zh_HK: {
    [key: string]: any
  }
  fr: {
    [key: string]: any
  }
}

type LangMapKey = keyof Messages

const messages = {
  en_WW: enLocal,
  zh_CN: zhLocal,
  zh_HK: hkLocal,
  fr: frLocal
}

export const i18n = createI18n({
  locale: getLanguage(), // set locale
  fallbackLocale: 'zh_CN', // set fallback locale
  messages, // set locale messages
  silentTranslationWarn: true,
  legacy: false,
  missingWarn: false,
  fallbackWarn: false
})

export function getLanguage() {
  const chooseLanguage = Cookies.get(langKey)
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage || '')
    .substring(0, 2)
    .toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (locale.indexOf(language) > -1) {
      return locale
    }
  }
  return 'zh_CN'
}

export function setLanguage(val: LangMapKey) {
  i18n.global.locale.value = val
  Cookies.set(langKey, val)
  window.postMessage(
    {
      type: 'changeLanguage',
      data: {
        lang: val
      }
    },
    window.origin
  )
}

export const langTextMap = {
  zh_CN: '简体中文',
  en_WW: 'English',
  zh_HK: '繁體中文',
  fr: 'Français'
}

export const $t = (args: string) => {
  return i18n.global.t(args)
}

export function installI18n(app: App<Element>) {
  app.use(i18n)
  app.provide('$t', $t)
  app.config.globalProperties.$t = $t
}

/**
 * 设置页面标题，逻辑根据router/index 内同步
 */
export function setDocumentTitle() {
  const to: any = router.currentRoute.value
  if (to.meta?.title) {
    document.title = to.meta.title
  }
  if (to.path === '/login') {
    document.title = $t('main_menu_route_login')
  } else {
    if (to.path === '/') {
      document.title = $t('main_menu_route_work_title')
    } else {
      const state: any = store.state
      const pageList: [] = state.menu.pageList
      const title: string = to.query?.title || ''
      const matchedRoute: any = pageList.find((page: any) => {
        return to.path === page.routeUrl
      })
      if (matchedRoute) {
        document.title = $t(title || matchedRoute.name)
      } else {
        document.title = '404'
        router.push('/404')
      }
    }
  }
}

/**
 * 是否为中文
 */
export const isCN = computed(() => {
  return i18n.global.locale.value === 'zh_CN' || i18n.global.locale.value === 'zh_HK'
})
